export enum FiLoginReminderTimePeriodType {
    Days = 0,
    Weeks = 1,
    Months = 2,
}

export enum FiLoginReminderSentResultType {
    Ok = 0,
    OptionIsNotSelected = 1,
    ErrorNotFound = 2,
    ErrorOther = 3,
}
